import { Form, Input, Button, message } from "antd"
import { MailOutlined, LockOutlined } from "@ant-design/icons"
import { apiUser } from "../../api"
import { useNavigate } from "react-router-dom"
import { useState, useEffect } from "react"
import { setConfig } from "../../lib/localstorage"
import { useStore } from "../../components/ui"
import { apiErrorMessage } from "../../lib/apiError"
import "./Login.scss"

const Login = () => {
  const { setAuth } = useStore()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [googleCfg, setGoogleCfg] = useState({ enabled: false, client_id: "" })

  useEffect(() => {
    apiUser
      .googleConfig()
      .then((res) => {
        const d = res?.data ?? res
        setGoogleCfg({ enabled: !!d?.enabled, client_id: d?.client_id || "" })
      })
      .catch(() => setGoogleCfg({ enabled: false, client_id: "" }))
  }, [])

  const applyAuth = (data) => {
    const menu = Array.isArray(data?.menu) ? data.menu : []
    setAuth({
      user: data?.user,
      menus: menu,
      logo: data?.base_link?.image_url || "",
      permissions: data?.permissions,
      token: "cookie-auth"  // placeholder — real token is in HTTP-only cookie
    })
    if (data?.base_link) setConfig("base_link", data.base_link)
    setTimeout(() => navigate("/dashboard"), 0)
  }

  const onFinish = async (values) => {
    setLoading(true)
    try {
      const res = await apiUser.login(values)
      applyAuth(res?.data ?? res)
    } catch (error) {
      message.error(apiErrorMessage(error, "Đăng nhập thất bại — kiểm tra email và mật khẩu"))
    } finally {
      setLoading(false)
    }
  }

  const onGoogleCredential = async (response) => {
    if (!response?.credential) return
    setLoading(true)
    try {
      const res = await apiUser.googleLogin(response.credential)
      applyAuth(res?.data ?? res)
    } catch (error) {
      message.error(apiErrorMessage(error, "Đăng nhập Google thất bại"))
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (!googleCfg.enabled || !googleCfg.client_id) return undefined
    const scriptId = "ees-google-gsi"
    const renderBtn = () => {
      if (!window.google?.accounts?.id) return
      window.google.accounts.id.initialize({
        client_id: googleCfg.client_id,
        callback: onGoogleCredential
      })
      const el = document.getElementById("ees-google-btn")
      if (el) {
        el.innerHTML = ""
        window.google.accounts.id.renderButton(el, {
          theme: "outline",
          size: "large",
          width: 340,
          text: "signin_with",
          shape: "rectangular"
        })
      }
    }
    if (document.getElementById(scriptId)) {
      renderBtn()
      return undefined
    }
    const s = document.createElement("script")
    s.id = scriptId
    s.src = "https://accounts.google.com/gsi/client"
    s.async = true
    s.onload = renderBtn
    document.body.appendChild(s)
    return undefined
  }, [googleCfg.enabled, googleCfg.client_id])

  return (
    <div className="ees-login">
      <div
        className="ees-login__bg"
        aria-hidden="true"
        style={{ backgroundImage: 'url("/images/login-bg.jpg")' }}
      />
      <div className="ees-login__veil" aria-hidden="true" />

      <div className="ees-login__shell">
        <section className="ees-login__brand">
          <div className="ees-login__brand-mark">
            <span className="ees-login__badge">EES</span>
            <span className="ees-login__brand-name">EES eZlog 2.0</span>
          </div>

          <div className="ees-login__hero">
            <span className="ees-login__eyebrow">Môi trường · Vận hành</span>
            <h1 className="ees-login__headline">Vận hành nhà máy XLNT rõ ràng hơn mỗi ngày</h1>
            <p className="ees-login__sub">
              Nhật ký, giám sát và báo cáo O&amp;M trên một nền tảng — dành cho đội vận hành và quản lý môi trường.
            </p>
          </div>
        </section>

        <div className="ees-login__panel-wrap">
          <div className="ees-login__panel">
            <h2 className="ees-login__panel-title">Đăng nhập</h2>
            <p className="ees-login__panel-desc">Dùng email công ty để vào hệ thống eZlog.</p>

            <Form
              className="ees-login__form"
              name="login"
              onFinish={onFinish}
              layout="vertical"
              requiredMark={false}
            >
              <Form.Item
                name="username"
                label="Email"
                rules={[{ required: true, message: "Vui lòng nhập email" }]}
              >
                <Input
                  size="large"
                  placeholder="ban@congty.com"
                  prefix={<MailOutlined style={{ color: "#8a9a94", marginRight: 6 }} />}
                  autoComplete="username"
                />
              </Form.Item>

              <Form.Item
                name="password"
                label="Mật khẩu"
                rules={[{ required: true, message: "Vui lòng nhập mật khẩu" }]}
              >
                <Input.Password
                  size="large"
                  placeholder="••••••••"
                  prefix={<LockOutlined style={{ color: "#8a9a94", marginRight: 6 }} />}
                  autoComplete="current-password"
                />
              </Form.Item>

              <Form.Item style={{ marginBottom: googleCfg.enabled ? 12 : 8 }}>
                <Button
                  className="ees-login__submit"
                  type="primary"
                  size="large"
                  htmlType="submit"
                  loading={loading}
                  block
                >
                  Đăng nhập
                </Button>
              </Form.Item>

              {googleCfg.enabled ? (
                <>
                  <div className="ees-login__divider">hoặc</div>
                  <div id="ees-google-btn" style={{ display: "flex", justifyContent: "center" }} />
                </>
              ) : null}
            </Form>

            <div className="ees-login__foot">© EES · eZlog 2.0</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login
